<template>
	<component :is="layout">
		<GlobalNotification />
		<Loader />
		<template v-if="!errorStore?.isNotFound && !errorStore?.isUnauthorized">
			<router-view />
		</template>
		<template v-else>
			<NotFoundPage v-if="errorStore?.isNotFound" />
			<UnauthorizedPage v-if="errorStore?.isUnauthorized" />
		</template>
	</component>
	<!-- Outside the layout on purpose: the admin layout ignores the slot, and
		a fixed bar must not sit inside a page container. -->
	<LegalAcceptanceBanner />
</template>
<script setup>
import '@/assets/css/includes.css';
import { useAuthStore } from '@/stores/auth';
const authStore = useAuthStore();
authStore.initialize();

import DefaultLayout from './layouts/DefaultLayout.vue';
import SecondaryLayout from './layouts/SecondaryLayout.vue';
import { watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import Loader from '@/components/Loader.vue';
import GlobalNotification from './components/GlobalNotification.vue';
import LegalAcceptanceBanner from './components/LegalAcceptanceBanner.vue';
import { useErrorStore } from './stores/errorStore';
import NotFoundPage from './views/NotFoundPage.vue';
import UnauthorizedPage from './views/UnauthorizedPage.vue';

const errorStore = useErrorStore();
const route = useRoute();

watch(
	() => route.meta.title,
	(title) => {
		document.title = title || 'EESA'
	},
	{ immediate: true }
);

const layout = computed(() => {
	// You can check meta field, or route name/path
	if (route.meta.layout === 'secondary') {
		return SecondaryLayout
	}

	return DefaultLayout;
})
</script>